import { ReactNode, useEffect, useState } from 'react';
import { Unit } from '../commons/interfaces/unit.interface';
import UnitContext from '../contexts/unit.context';
import ChatbotAPI from '../services/chatbot.service';

const chatbotAPI = new ChatbotAPI();

const UnitProvider = ({ children }: { children: ReactNode }) => {
  const [units, setUnits] = useState<Unit[]>([]);

  useEffect(() => {
    const fetchUnits = async () => {
      const response = await chatbotAPI.listUnits();
      setUnits(response.data.data);
    };

    fetchUnits();
  }, []);

  const value = {
    units
  };

  return <UnitContext.Provider value={value}>{children}</UnitContext.Provider>;
};

export default UnitProvider;
